export default __webpack_public_path__ + "static/media/Statistics_2012.e0a7885f.zip";